const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const waitForVideo = (scope) =>
  new Promise((resolve) => {
    const existingVideo = scope.querySelector('video');
    if (existingVideo) {
      resolve(existingVideo);
      return;
    }

    const observer = new MutationObserver(() => {
      const video = scope.querySelector('video');
      if (!video) return;

      observer.disconnect();
      resolve(video);
    });

    observer.observe(scope, { childList: true, subtree: true });
    window.setTimeout(() => {
      observer.disconnect();
      resolve(scope.querySelector('video'));
    }, 1500);
  });

const playVideo = async (scope) => {
  if (!hoverCapable.matches || reducedMotion.matches) return;

  let video = scope.querySelector('video');

  if (!video) {
    scope.querySelector('[ref="deferredMediaPlayButton"]')?.click();
    video = await waitForVideo(scope);
  } else {
    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  }

  if (!video || !scope.matches(':hover')) return;

  video.muted = true;
  video.loop = true;
  video.playsInline = true;
  video.play().catch(() => {});
};

const stopVideo = (scope) => {
  const video = scope.querySelector('video');
  if (!video) return;

  video.pause();
  video.currentTime = 0;
};

document.addEventListener('pointerover', (event) => {
  const scope = event.target.closest('[data-sv-hover-video-scope]');
  if (!scope || scope.contains(event.relatedTarget)) return;

  playVideo(scope);
});

document.addEventListener('pointerout', (event) => {
  const scope = event.target.closest('[data-sv-hover-video-scope]');
  if (!scope || scope.contains(event.relatedTarget)) return;

  stopVideo(scope);
});
